module.exports = __webpack_public_path__ + "img/not-authorized.699fd496.svg";